var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 6.5,
  y: 14.5,
  width: 25.5,
  height: 17,
  rx: 2,
  fill: "#dfe6ec"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m7.2 15.6 12 8.8 12-8.8",
  fill: "none",
  stroke: "#8f9ba3",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m7.6 30.4 8.4-6.4",
  fill: "none",
  stroke: "#8f9ba3",
  strokeWidth: 1.2,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m30.8 30.4-8.4-6.4",
  fill: "none",
  stroke: "#8f9ba3",
  strokeWidth: 1.2,
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 10,
  r: 6,
  fill: "#e0704f"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 35.15,
  y: 6.8,
  width: 1.7,
  height: 6.4,
  rx: 0.85,
  fill: "#ffffff"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 32.8,
  y: 9.15,
  width: 6.4,
  height: 1.7,
  rx: 0.85,
  fill: "#ffffff"
});

function SvgMailRequest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailRequest);
export default __webpack_public_path__ + "static/media/mail-request.f8f60869844ecdc8bd1640b01efa193a.svg";
export { ForwardRef as ReactComponent };